module.exports = __webpack_public_path__ + "img/2019091202.0fb84399.png";